import { QueryClient } from "@tanstack/react-query";

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // The API is cross-origin and every request carries the session
        // cookie; refetching on every mount would multiply that traffic for
        // data that changes on the order of minutes.
        staleTime: 30_000,
        // An expired session or a denied capability is not worth retrying:
        // the answer will not change, and the retry delays the redirect.
        retry: (failureCount, error) => {
          const status = (error as { status?: number }).status;
          if (status === 401 || status === 403 || status === 404) return false;
          return failureCount < 2;
        },
      },
    },
  });
}
